import { TriangleAlert } from "lucide-react";
import type { WriteRejection } from "@estelle/domain";

import { describeRejection } from "@/modules/docs/writeRejection";

/** A `WriteRejection` rendered as what it actually is. */
export function RejectionNotice({ rejection }: { rejection: WriteRejection }) {
  return (
    <p className="text-destructive flex items-start gap-1.5 text-xs">
      <TriangleAlert className="mt-0.5 size-3.5 shrink-0" aria-hidden />
      {describeRejection(rejection)}
    </p>
  );
}
